import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi.js';
import { useNavigate } from 'react-router-dom';

const Manage = () => {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([])
  const [selectedHeroNos, setSelectedHeroNos] = useState([])

  const load = async () => {
    const tasks = await butterflyApi.getTasks()
    if (tasks && tasks.length > 0) {
      const tasksByObj = Object.groupBy(tasks, (task) =>
        `${task.heroNo}_${task.scriptNo}`
      );
      const tasksBy = Object.entries(tasksByObj).map(([key, tasks]) => {
        return {
          key: key,
          heroNo: tasks[0].heroNo,
          scriptNo: tasks[0].scriptNo,
          registerDatetime: tasks[0].registerDatetime,
          items: tasks,
        }
      });
      tasksBy.sort((a, b) => b.registerDatetime - a.registerDatetime)
      setTasks(tasksBy)
      const heroNos = [...new Set(tasksBy.map(t => t.heroNo))]
      setSelectedHeroNos(heroNos)
    } else {
      setTasks([])
    }
  }

  const toggleHeroNo = (heroNo) => {
    setSelectedHeroNos(prev =>
      prev.includes(heroNo) ? prev.filter(n => n !== heroNo) : [...prev, heroNo]
    )
  }

  useEffect(() => {
    load();
  }, [])

  return <div className="px-4 mt-12">
    <div className='mb-8' onClick={() => navigate(`/`)}>
      <img className='w-16' src='/image/tellingpapa_text.png' />
    </div>
    <div className='flex gap-3'>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/history">History</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/script">Script</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/heroes">Heroes</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/image-update">ImageUpdate</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/holding-tasks">HoldingTasks</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/inquiries">Inquiries</a>
      </div>
      <div className='my-4 font-bold underline text-blue-500'>
        <a href="/manage/app-payment-orders">AppPaymentOrders</a>
      </div>
    </div>

    <div className='flex flex-wrap gap-3 mb-4'>
      <label className='flex items-center gap-1 cursor-pointer font-bold'>
        <input
          type='checkbox'
          checked={selectedHeroNos.length === [...new Set(tasks.map(t => t.heroNo))].length}
          onChange={() => {
            const allHeroNos = [...new Set(tasks.map(t => t.heroNo))]
            setSelectedHeroNos(selectedHeroNos.length === allHeroNos.length ? [] : allHeroNos)
          }}
        />
        <span>ALL</span>
      </label>
      {[...new Map(tasks.map(t => [t.heroNo, t.items?.[0]?.heroName])).entries()].map(([heroNo, heroName]) => (
        <label key={heroNo} className='flex items-center gap-1 cursor-pointer'>
          <input
            type='checkbox'
            checked={selectedHeroNos.includes(heroNo)}
            onChange={() => toggleHeroNo(heroNo)}
          />
          <span>{heroNo} {heroName}</span>
        </label>
      ))}
    </div>

    {
      tasks && tasks.filter(task => {
        return selectedHeroNos.includes(task.heroNo) &&
          (task.items?.[0].lastViewDatetime || (new Date() - new Date(task.items?.[0].registerDatetime) < 3 * 24 * 60 * 60 * 1000))
      }).sort(
        (a, b) => new Date(b.items?.[0].lastViewDatetime) - new Date(a.items?.[0].lastViewDatetime)
      ).map(task => {
        const items = task.items
        return (
          <div key={task.key} className='mt-4 border-2 p-4 flex gap-5 items-start' onClick={() => navigate(`/manage/story?heroNo=${items?.[0].heroNo}&scriptNo=${items?.[0].scriptNo}`)}>
            <div className='w-24 flex-shrink-0'>
              <img src={items?.[0].imageUrl} alt="" />
            </div>
            <div>
              <div>
                검증일 : {items?.[0].verifiedDatetime}
              </div>
              <div>
                노티일 : {items?.[0].notifyDatetime}
              </div>
              <div>
                조회일: {items?.[0].lastViewDatetime}
              </div>
              <div>
                heroNo : <a href={`/manage/hero?heroNo=${items?.[0].heroNo}`} className="text-blue-600 underline" onClick={e => e.stopPropagation()}>{items?.[0].heroNo}</a>
              </div>
              <div>
                heroName : {items?.[0].heroName}
              </div>
              <div>
                scriptNo : <a href={`/manage/script?scriptNo=${items?.[0].scriptNo}`} className="text-blue-600 underline" onClick={e => e.stopPropagation()}>{items?.[0].scriptNo}</a>
              </div>
              <div>
                title : {items?.[0].title}
              </div>
            </div>
          </div>
        )
      })
    }
  </div>
}

export default Manage
